module.exports = __webpack_public_path__ + "img/trois-battants.0df8474.svg";